import useFetchPatientSubscriptionsQuery from 'App/hooks/useFetchPatientSubscriptionsQuery';
import { useMemo } from 'react';
import getPatientMessageEnrollmentStatus from 'App/utils/getPatientMesssageEnrollmentStatus';

function useGetPatientSubscriptionStatusQuery(patientId) {
    const { data } = useFetchPatientSubscriptionsQuery(patientId);

    const result = useMemo(() => {
        return getPatientMessageEnrollmentStatus(data);
    }, [data]);

    return result;
}

export default useGetPatientSubscriptionStatusQuery;
